// @ts-expect-error untyped dep
import { handleActions, combineActions } from 'flux-actions';
import { REGISTER_SMS, VERIFY_SMS, VERIFICATION_SUCCESSFUL, CHANGE_SECURITY_NUMBER } from '../../constants/security/SecurityPhoneNumberSetupSteps';
import { indexOfStep } from '../../constants/security/SecurityPhoneNumberSetupStepOrder';
import { SecurityPhoneNumberActionTypes } from '../../actions/security/SecurityPhoneNumberActions';
import { TwoFactorAuthActionTypes } from '../../actions/TwoFactorAuthActions';
import TwoFactorAuthSMSErrors from '../../constants/TwoFactorAuthSMSErrors';
import { SecurityPhoneNumberSetupState } from '../../records/security/SecurityPhoneNumberSetupState';
const initialState = new SecurityPhoneNumberSetupState();
export default handleActions({
  [SecurityPhoneNumberActionTypes.CLICKED_SETUP](state, action) {
    if (action.payload && action.payload.numberExist) {
      return state.merge({
        setupStepIndex: indexOfStep(CHANGE_SECURITY_NUMBER)
      });
    }
    return state.merge({
      setupStepIndex: indexOfStep(REGISTER_SMS)
    });
  },
  [SecurityPhoneNumberActionTypes.CLICKED_VERIFY](state) {
    return state.merge({
      setupStepIndex: indexOfStep(VERIFY_SMS)
    });
  },
  [combineActions(SecurityPhoneNumberActionTypes.COMPLETED_SETUP, SecurityPhoneNumberActionTypes.CANCELLED_SETUP)](state) {
    if (!state.redirectUrl) {
      return state.merge(initialState);
    }
    return state;
  },
  [SecurityPhoneNumberActionTypes.FETCH_CONFIGURATION_SUCCESSFUL](state, action) {
    if (!action.payload) {
      return state;
    }
    return state.merge({
      stagedSMSNumber: action.payload.securityPhoneNumber.info
    });
  },
  [TwoFactorAuthActionTypes.CONFIRMED_VALIDATION_REQUEST](state) {
    return state.merge({
      stagedSMSNumber: '',
      isErrorSendingSMS: undefined
    });
  },
  [TwoFactorAuthActionTypes.CONFIRMED_VALIDATION_SUCCESS](state, action) {
    if (!action.payload) {
      return state;
    }
    const {
      response,
      phoneNumber
    } = action.payload;
    if (response.isValid && response.geoPermission !== TwoFactorAuthSMSErrors.NOT_ALLOWED) {
      return state.set('stagedSMSNumber', phoneNumber);
    }
    return state;
  },
  [TwoFactorAuthActionTypes.CONFIRMED_VALIDATION_FAILURE](state, action) {
    if (!action.payload) {
      return state;
    }
    const {
      phoneNumber
    } = action.payload;
    return state.merge({
      stagedSMSNumber: phoneNumber,
      isErrorSendingSMS: undefined
    });
  },
  [SecurityPhoneNumberActionTypes.CONFIGURE_SMS](state) {
    return state.merge({
      verificationCodeAttempt: '',
      verificationCodeFailure: false
    });
  },
  [SecurityPhoneNumberActionTypes.CHANGE_SECURITY_NUMBER](state) {
    return state.merge({
      verificationCodeAttempt: '',
      verificationCodeFailure: false
    });
  },
  [SecurityPhoneNumberActionTypes.CONFIGURE_SMS_SUCCESS](state) {
    return state.mergeDeep({
      setupStepIndex: indexOfStep(VERIFY_SMS),
      isErrorSendingSMS: false
    });
  },
  [SecurityPhoneNumberActionTypes.CONFIGURE_SMS_FAILURE](state) {
    return state.set('isErrorSendingSMS', true);
  },
  [SecurityPhoneNumberActionTypes.CODE_ATTEMPT_SUCCESS](state) {
    return state.merge({
      setupStepIndex: indexOfStep(VERIFICATION_SUCCESSFUL)
    });
  },
  [SecurityPhoneNumberActionTypes.CODE_ATTEMPT_FAILURE](state) {
    return state.merge({
      verificationCodeFailure: true
    });
  },
  [SecurityPhoneNumberActionTypes.CHANGED_CODE_ATTEMPT](state, action) {
    if (!action.payload) {
      return state;
    }
    return state.merge({
      verificationCodeAttempt: action.payload.codeAttempt,
      verificationCodeFailure: false
    });
  },
  [SecurityPhoneNumberActionTypes.DELETE_SECURITY_NUMBER_SUCCESS](state) {
    return state.set('stagedSMSNumber', '');
  }
}, initialState);